import React from "react";

const CRMRequestTableComponentLoadable = React.lazy(() => import("./CRMRequestTableComponent"));
const EnquiryTableComponentLoadable = React.lazy(() => import("./Enquiry"));
const EnquiryTabComponentLoadable = React.lazy(() => import("./Enquiry/EnquiryTabComponent"));
const FinanceApprovalComponentLoadable = React.lazy(() => import("./FinanceApprovalComponent"));
const FinanceApprovalTabComponentLoadable = React.lazy(() => import("./FinanceApprovalTabComponent"));



export { CRMRequestTableComponentLoadable, EnquiryTableComponentLoadable, EnquiryTabComponentLoadable, FinanceApprovalComponentLoadable , FinanceApprovalTabComponentLoadable};